import { useAuthStore } from "@/stores/authStore";
import { PRODUCTION_HOSTNAMES } from "@/consts";
import { LocalStorageKeys } from "@/enums";
import { computed } from "vue";

export function usePlannerPermissions() {
  const authStore = useAuthStore();

  const view = computed(() => {
    return (
      authStore.currentInstitution?.settings.planner.enabledEmployees || false
    );
  });

  const viewNew = computed(() => {
    if (PRODUCTION_HOSTNAMES.includes(window.location.host)) {
      return false;
    }

    return localStorage.getItem(LocalStorageKeys.ActivateNewPlanner) === "true";
  });

  return { view, viewNew };
}
